/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Ordered_By_Time_ToastInputs */

const en_shortcut_keys_ordered_by_time_toast = /** @type {(inputs: Shortcut_Keys_Ordered_By_Time_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events ordered by time successfully`)
};

const fr_shortcut_keys_ordered_by_time_toast = /** @type {(inputs: Shortcut_Keys_Ordered_By_Time_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenements tries par temps avec succes`)
};

const de_shortcut_keys_ordered_by_time_toast = /** @type {(inputs: Shortcut_Keys_Ordered_By_Time_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse erfolgreich nach Zeit sortiert`)
};

const it_shortcut_keys_ordered_by_time_toast = /** @type {(inputs: Shortcut_Keys_Ordered_By_Time_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi ordinati correttamente in base al tempo`)
};

const ru_shortcut_keys_ordered_by_time_toast = /** @type {(inputs: Shortcut_Keys_Ordered_By_Time_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`События, упорядоченные по времени, успешно завершены.`)
};

const es_shortcut_keys_ordered_by_time_toast = /** @type {(inputs: Shortcut_Keys_Ordered_By_Time_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos ordenados por tiempo con éxito`)
};

const zh_cn2_shortcut_keys_ordered_by_time_toast = /** @type {(inputs: Shortcut_Keys_Ordered_By_Time_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按时间排序的事件成功`)
};

const ja_shortcut_keys_ordered_by_time_toast = /** @type {(inputs: Shortcut_Keys_Ordered_By_Time_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントは時間順に並べられました`)
};

const hi_shortcut_keys_ordered_by_time_toast = /** @type {(inputs: Shortcut_Keys_Ordered_By_Time_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय के अनुसार क्रमबद्ध की गई घटनाएँ सफलतापूर्वक`)
};

const pt_pt2_shortcut_keys_ordered_by_time_toast = /** @type {(inputs: Shortcut_Keys_Ordered_By_Time_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos ordenados por tempo com sucesso`)
};

/**
* | output |
* | --- |
* | "Events ordered by time successfully" |
*
* @param {Shortcut_Keys_Ordered_By_Time_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_ordered_by_time_toast = /** @type {((inputs?: Shortcut_Keys_Ordered_By_Time_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Ordered_By_Time_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_ordered_by_time_toast(inputs)
	if (locale === "de") return de_shortcut_keys_ordered_by_time_toast(inputs)
	if (locale === "it") return it_shortcut_keys_ordered_by_time_toast(inputs)
	if (locale === "ru") return ru_shortcut_keys_ordered_by_time_toast(inputs)
	if (locale === "es") return es_shortcut_keys_ordered_by_time_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_ordered_by_time_toast(inputs)
	if (locale === "ja") return ja_shortcut_keys_ordered_by_time_toast(inputs)
	if (locale === "hi") return hi_shortcut_keys_ordered_by_time_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_ordered_by_time_toast(inputs)
	return en_shortcut_keys_ordered_by_time_toast(inputs)
});